<div class="cg-dialog">
  <h2 class="cg-dialog__header">
    Privacy<button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="dialogRef.close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <p>
      <a
        href="http://www.cigna.com/privacyinformation/online-privacy-statement.html"
        target="_blank"
        rel="noopener noreferrer"
        >Online Privacy Statement</a
      ><br />Describes how we handle your personal information when you visit
      our websites.
    </p>
    <p>
      <a
        href="http://www.cigna.com/privacyinformation/privacy-notices-and-forms/index.html"
        target="_blank"
        rel="noopener noreferrer"
        >Cigna Notices of Privacy Practices</a
      ><br />Describes how Cigna collects, treats, and protects information
      about you.
    </p>
    <p>
      <a
        [href]="
          '/pdf/resourceLibrary/Privacy/CignaHealthServiceProviderWebsiteNoticeNYDomViolence071213.pdf'
            | resourceLink : { type: 'file', secure: false }
            | async
        "
        target="_blank"
        >Cigna Health Service Provider Notice</a
      ><br />Protocols for Victims of Domestic Violence Residing in New York.
    </p>
  </mat-dialog-content>
</div>
